import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  readonly isVerifiedApi = environment.KUDOSHUB_JAVA_HOST_URL + 'api/isVerified';
  readonly addSubscriberApi = environment.KUDOSHUB_BACKEND_HOST + 'api/add-subscriber';
  readonly activateSubscriberApi = environment.KUDOSHUB_BACKEND_HOST + 'api/activate-subscriber';
  readonly validateSubscriberApi = environment.KUDOSHUB_BACKEND_HOST + 'api/validate-subscriber';
  readonly unSubscribeApi = environment.KUDOSHUB_BACKEND_HOST + 'api/unsubscribe-subscriber';
  readonly subscribeUnsubscriberApi = environment.KUDOSHUB_BACKEND_HOST + 'api/subscribe-unsubscriber';
  readonly spinOffersWheelApi = environment.KUDOSHUB_BACKEND_HOST + 'api/spin-offers-wheel';
  readonly createUserOfferApi = environment.KUDOSHUB_BACKEND_HOST + 'api/create-user-offer';
    // check email id for exist or not for register
    readonly checkEmailApi =environment.KUDOSHUB_BACKEND_HOST+"api/check-user-exists";

  constructor(
    private http: HttpClient,
    private handler: HttpBackend,
    private newHttp: HttpClient
  ) { }

  // isVerified (subscriber Api)
  isVerified(email: string, from: string) {
    this.newHttp = new HttpClient(this.handler);
    return this.newHttp.get(this.isVerifiedApi + '/' + email + '/' + from);
  }
  // add subscriber
  addSubscriber(email: any) {
    return this.http.post(this.addSubscriberApi, email);
  }

  //activate subscriber
  activateSubscriber(token: any) {
    return this.http.post(this.activateSubscriberApi, token);
  }

  //validate subscriber
  validateSubscriber(uniqueId: any) {
    return this.http.post(this.validateSubscriberApi, uniqueId);
  }

  //unsubscribe
  unSubscribeSubscriber(uniqueIdAndReason: any) {
    return this.http.post(this.unSubscribeApi, uniqueIdAndReason);
  }

  //subscriber unsubscriber
  subscriberUnsubscriber(uniqId: any) {
    return this.http.post(this.subscribeUnsubscriberApi, uniqId);
  }

  //spin offers wheel
  spinOffersWheel(request: any) {
    return this.http.post(this.spinOffersWheelApi, request);
  }

  //create user offer
  createUserOffer(request: any) {
    return this.http.post(this.createUserOfferApi, request);
  }

  checkUserEmail(email: any){
    return this.http.post(this.checkEmailApi, email);
  }
}
